var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "basket",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18783",
    "data-name": "Gruppe 18783",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24194",
    "data-name": "Rechteck 24194",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18784",
    "data-name": "Gruppe 18784",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283709",
    "data-name": "Pfad 283709",
    d: "M21.5,19.15a.576.576,0,0,0,.575-.575v-.5a2.925,2.925,0,1,1,5.85,0v.5a.575.575,0,0,0,1.15,0v-.5a4.075,4.075,0,0,0-8.15,0v.5A.576.576,0,0,0,21.5,19.15Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283710",
    "data-name": "Pfad 283710",
    d: "M33.312,31.691,31.061,21H18.939L16.688,31.691A3.076,3.076,0,0,0,19.7,35.4H30.3a3.076,3.076,0,0,0,3.009-3.709ZM30.127,22.15l2.06,9.779A1.926,1.926,0,0,1,30.3,34.25H19.7a1.926,1.926,0,0,1-1.884-2.321l2.06-9.779Z",
    fill: "#1d1d1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.2c25062b4e70efc1e65d25d5ab1046f4.svg";
export { ForwardRef as ReactComponent };